// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.f3Ivct8hf_ {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.f3Ivct8hf_ h4 {
  line-height: 3em;
}
.f3Ivct8hf_ .ZOy1RADCd1 {
  float: left;
  width: 100%;
}
.f3Ivct8hf_ .Qzbh3eciFA {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.f3Ivct8hf_ .Qzbh3eciFA:hover {
  cursor: pointer;
}
.f3Ivct8hf_ .Qzbh3eciFA:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.Oe2PvC591F .AMMCeahMPl:focus {
  outline: none;
}
.Oe2PvC591F .AMMCeahMPl.V7tonH6tUB.siwjj9mGL0 {
  background: #375A88;
}
.Oe2PvC591F .AMMCeahMPl.V7tonH6tUB.siwjj9mGL0 span {
  color: #fff;
}
.Oe2PvC591F .siwjj9mGL0 {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.Oe2PvC591F .siwjj9mGL0:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.Oe2PvC591F input {
  height: 38px;
  min-width: 220px;
}
.Qzbh3eciFA.kiHB6so_80 {
  background: #410102;
}
.Qzbh3eciFA.eOMv88tmB4 {
  background: #911318;
}
.Qzbh3eciFA.L22nFikLNW {
  background: #D8293B;
}
.Qzbh3eciFA.uXXI6dsZet {
  background: #F2373C;
}
.Qzbh3eciFA.IG9qBemAlT {
  background: #FC4448;
}
.Qzbh3eciFA.MXM3o5QUmz {
  background: #ED535E;
}
.Qzbh3eciFA.cXTRZo6QrK {
  background: #E34926;
}
.Qzbh3eciFA.tLskiQkvM6 {
  background: #FC562B;
}
.Qzbh3eciFA.zeZ5PAN3uz {
  background: #FC6722;
}
.Qzbh3eciFA.NE3t1nmHtX {
  background: #FD7F24;
}
.Qzbh3eciFA.P8lnMNMlTI {
  background: #FD8D26;
}
.Qzbh3eciFA.f3qNzJzsZL {
  background: #EC9C3E;
}
.Qzbh3eciFA.cOJGzpzLjJ {
  background: #0e673a;
}
.Qzbh3eciFA._nALHJgcCI {
  background: #208740;
}
.Qzbh3eciFA.f350ymvm7M {
  background: #239718;
}
.Qzbh3eciFA.DR48ioIP3M {
  background: #55A84D;
}
.Qzbh3eciFA.cZbjTf4fJ6 {
  background: #4BBE5A;
}
.Qzbh3eciFA.X9CNioQH5p {
  background: #0CCA6A;
}
.Qzbh3eciFA.aWfhbGoY7H {
  background: #0A3C64;
}
.Qzbh3eciFA.yHkoxDgHFE {
  background: #0d487a;
}
.Qzbh3eciFA.rFhmen230A {
  background: #10538d;
}
.Qzbh3eciFA.uuSaSGNe5U {
  background: #115A99;
}
.Qzbh3eciFA.qV3qwwvd_S {
  background: #3387E2;
}
.Qzbh3eciFA.G5aOgaXvFO {
  background: #1BA9CF;
}
.Qzbh3eciFA.QnSyuaON_F {
  background: #d27c02;
}
.Qzbh3eciFA._YPiEPIVOK {
  background: #fb9402;
}
.Qzbh3eciFA.gDHfuavBp1 {
  background: #FD9B30;
}
.Qzbh3eciFA.C8BMtL3Jbp {
  background: #FDBE2D;
}
.Qzbh3eciFA.xjR6z0tJC5 {
  background: #FED831;
}
.Qzbh3eciFA.J86RqadwnV {
  background: #FFFD38;
}
.Qzbh3eciFA.HezURBx7dQ {
  background: #2D215C;
}
.Qzbh3eciFA.Gb8y2iwzhY {
  background: #483C83;
}
.Qzbh3eciFA.lxZovG5gaI {
  background: #58518d;
}
.Qzbh3eciFA.CQFED4h8Te {
  background: #7068A9;
}
.Qzbh3eciFA.Wyc9U8P_m7 {
  background: #7f78b2;
}
.Qzbh3eciFA.D_tfDGXFP5 {
  background: #8f88bc;
}
.Qzbh3eciFA.R_UVGHIx1s {
  background: #000;
}
.Qzbh3eciFA.VJYmwOnywF {
  background: #282626;
}
.Qzbh3eciFA.D5HqreOII1 {
  background: #242222;
}
.Qzbh3eciFA.ILHX_1Y8Zx {
  background: #353838;
}
.Qzbh3eciFA._94qtsrohCl {
  background: #666;
}
.Qzbh3eciFA.txjo1TYruJ {
  background: #999;
}
.Y3lI8xvbL1 {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.Y3lI8xvbL1 .l3jgQYCZrz {
  display: none;
}
.cvsyhDHvlh.cvsyhDHvlh.cvsyhDHvlh {
  margin: 0;
  padding: 12px 14px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  height: 37px;
  font-size: 11px;
  font-weight: 400;
  text-transform: capitalize;
  letter-spacing: 0px;
}
.cvsyhDHvlh.cvsyhDHvlh.cvsyhDHvlh .JYo_xEe6KO {
  margin-top: 1px;
}
.B88B9HcrV5 .DrVFJEbGKH.DrVFJEbGKH {
  border-bottom: solid 1px #ebebeb;
  margin: 0;
}
.B88B9HcrV5 .DrVFJEbGKH.Of5LPagybs {
  color: #999999;
  line-height: 13px;
  font-style: italic;
  font-weight: bold;
}
.B88B9HcrV5:last-child .DrVFJEbGKH:last-child {
  border-bottom: none;
}
.wHp2VQJAwb + .wHp2VQJAwb {
  border-top: solid 1px #ebebeb;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `f3Ivct8hf_`,
	"color-row": `ZOy1RADCd1`,
	"color-tile": `Qzbh3eciFA`,
	"picker-component": `Oe2PvC591F`,
	"picker-element": `AMMCeahMPl`,
	"active": `V7tonH6tUB`,
	"btn": `siwjj9mGL0`,
	"red-1": `kiHB6so_80`,
	"red-2": `eOMv88tmB4`,
	"red-3": `L22nFikLNW`,
	"red-4": `uXXI6dsZet`,
	"red-5": `IG9qBemAlT`,
	"red-6": `MXM3o5QUmz`,
	"orange-1": `cXTRZo6QrK`,
	"orange-2": `tLskiQkvM6`,
	"orange-3": `zeZ5PAN3uz`,
	"orange-4": `NE3t1nmHtX`,
	"orange-5": `P8lnMNMlTI`,
	"orange-6": `f3qNzJzsZL`,
	"green-1": `cOJGzpzLjJ`,
	"green-2": `_nALHJgcCI`,
	"green-3": `f350ymvm7M`,
	"green-4": `DR48ioIP3M`,
	"green-5": `cZbjTf4fJ6`,
	"green-6": `X9CNioQH5p`,
	"blue-1": `aWfhbGoY7H`,
	"blue-2": `yHkoxDgHFE`,
	"blue-3": `rFhmen230A`,
	"blue-4": `uuSaSGNe5U`,
	"blue-5": `qV3qwwvd_S`,
	"blue-6": `G5aOgaXvFO`,
	"yellow-1": `QnSyuaON_F`,
	"yellow-2": `_YPiEPIVOK`,
	"yellow-3": `gDHfuavBp1`,
	"yellow-4": `C8BMtL3Jbp`,
	"yellow-5": `xjR6z0tJC5`,
	"yellow-6": `J86RqadwnV`,
	"purple-1": `HezURBx7dQ`,
	"purple-2": `Gb8y2iwzhY`,
	"purple-3": `lxZovG5gaI`,
	"purple-4": `CQFED4h8Te`,
	"purple-5": `Wyc9U8P_m7`,
	"purple-6": `D_tfDGXFP5`,
	"black-1": `R_UVGHIx1s`,
	"black-2": `VJYmwOnywF`,
	"black-3": `D5HqreOII1`,
	"black-4": `ILHX_1Y8Zx`,
	"black-5": `_94qtsrohCl`,
	"black-6": `txjo1TYruJ`,
	"picker-theme": `Y3lI8xvbL1`,
	"arrow-regular": `l3jgQYCZrz`,
	"action-menu__itemDefault": `cvsyhDHvlh`,
	"action-menu__btn--iconRoot": `JYo_xEe6KO`,
	"action-menu__listItem": `B88B9HcrV5`,
	"action-menu__itemGroup": `DrVFJEbGKH`,
	"action-menu__itemGroup--label": `Of5LPagybs`,
	"action-menu__item": `wHp2VQJAwb`
};
export default ___CSS_LOADER_EXPORT___;
